import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Badge, Col, Row } from 'react-bootstrap';

import { useStore } from '../../../../store';
import Loading from '../../../../facturotopia/loading/Loading';
import PageHeader from '../../../../support/page-header/PageHeader';
import RecepcionStatusBadge from './components/RecepcionStatusBadge';
import RecepcionGeneralInfo from './components/RecepcionGeneralInfo';
import RecepcionItemActions from './components/RecepcionItemActions';
import RecepcionValidacionInfo from './components/RecepcionValidacionInfo';
import TipoComprobante from '../../../../app/comprobantes/support/enum/TipoComprobante';

class RecepcionFilesInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id }
    }
  }

  componentDidMount() {
    const { data } = this.state;

    this.props.info(data.id);
  }

  renderValidaciones = (item) => (
    <RecepcionValidacionInfo key={ item.validation } data={ item } />
  )

  render() {
    const { busy, data = {} } = this.props;
    const { validations = {} } = data;

    if (busy) {
      return <Loading />
    }

    const tipo = TipoComprobante.search(data.tipo_comprobante) || TipoComprobante.undefined()

    return (
      <>
        <PageHeader to="/modulos/recepcion" text="Recepción" />

        <h5>
          { data.cfdi_uuid }
        </h5>

        { !!data.cfdi_uuid && (
          <div>

            <Row className="mt-3 mb-1">
              <Col xs={ 12 } sm={ 12 } md={ 8 } className="mb-2">
                <div className="d-inline-block mr-3">
                  <span className="text-muted">Comprobante:</span>
                  <br/>
                  <Badge pill variant="info">
                    { tipo.getName() || '...' }
                  </Badge>
                </div>

                <div className="d-inline-block mr-3">
                  <span className="text-muted">Valid:</span>
                  <br/>
                  <RecepcionStatusBadge valid={ data.valid } />
                </div>
              </Col>

              { Guardian.allows('recepcion.descargar.archivo.original') && (
                <Col className="text-right">
                  <RecepcionItemActions
                    data={ data }
                  />
                </Col>
              )}
            </Row>

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <RecepcionGeneralInfo data={ data } />


            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Validaciones</strong>
            </div>

            { !!validations && validations.map(this.renderValidaciones) }
          </div>
        )}
      </>
    );
  }
}

const mapState = (state) => {
  return state.modulo.recepcion.info;
}

const mapActions = (actions) => {
  return actions.modulo.recepcion.info;
}

export default connect(useStore, mapState, mapActions)(RecepcionFilesInfo);